import {ThunkAction} from "redux-thunk";
import {AlbumInfo} from "../models/responses";
import MediaItem from "../models/media-item";
import {RootState} from "../reducers/root-reducer";


export const UPLOAD_FILES = `UPLOAD_FILES`
export const ALL_FILES_UPLOADED = `ALL_FILES_UPLOADED`
export const FILE_UPLOADED = `FILE_UPLOADED`
export const UPLOADING_PROGRESS = `UPLOADING_PROGRESS`
// export const UPLOADING_ERROR = `UPLOADING_ERROR` 

export interface UploadFilesAction {
    type: typeof UPLOAD_FILES
    files: File[]
    activeFile: File
    album: AlbumInfo
}
export interface AllFilesUploadedAction {
    type: typeof ALL_FILES_UPLOADED
}

export interface FileUploadedAction {
    type: typeof FILE_UPLOADED
    item: MediaItem
}

export interface UploadingProgressAction {
    type: typeof UPLOADING_PROGRESS
}

export type FileUploadActions = UploadFilesAction | AllFilesUploadedAction | UploadingProgressAction | FileUploadedAction

export type FileUploadResult<R> = ThunkAction<R, RootState, undefined, FileUploadActions>